import { createSelector } from 'utils/app.util';

export const getFacilityDocumentsFromState = createSelector(
  (state) => state.getIn(['entity', 'facilities', 'facilityDocuments']),
  (documents) => documents,
);
